import React from "react"
import { Grid, Paper } from "@mui/material"
import PropTypes from "prop-types"
import { useCostCalculations } from "./hooks/useCostCalculations"
import GeneralDataSection from "./components/GeneralDataSection"
import AccountingSection from "./components/AccountingSection"
import AmountsSection from "./components/AmountsSection"

const CostItem = ({ formData, handleInputChange, readOnlyAmounts }) => {
  useCostCalculations(formData, handleInputChange)

  return (
    <Paper
      variant="outlined"
      sx={{
        p: 2,
        borderRadius: 2,
        backgroundColor: "#fdfdfd",
      }}
    >
      <Grid container spacing={2}>
        <GeneralDataSection
          formData={formData}
          handleInputChange={handleInputChange}
        />

        <AccountingSection
          formData={formData}
          handleInputChange={handleInputChange}
        />

        <AmountsSection
          formData={formData}
          handleInputChange={handleInputChange}
          readOnlyAmounts={readOnlyAmounts}
        />
      </Grid>
    </Paper>
  )
}

CostItem.propTypes = {
  formData: PropTypes.object.isRequired,
  handleInputChange: PropTypes.func.isRequired,
  readOnlyAmounts: PropTypes.bool,
}

export default CostItem
